module.exports = __webpack_public_path__ + "img/atv.f7af98fe.svg";